// extracted by mini-css-extract-plugin
export default {"container":"label_container__stmvx","style_dot":"label_style_dot__omXnJ","style_string":"label_style_string__l29ZB"};